
import TableList from "@components/templates/tablelist";
import compCopy from "./copy";
import {
    HttpGetStockDistributionList,
    HttpCancelStockDistribution
} from "@/service/stockdistribution/index";
import { mapGetters } from "vuex";
import compIndex from "./update";
import compAuthModal from "./modal";
import mixin from "./mixin";
import Cookies from "js-cookie";
import "./index.scss";
export default {
    mixins: [TableList, mixin],
    components: {
        compIndex,
        compCopy,
        compAuthModal
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            // spanTabs: { show: true },
            formData: {
                search: {
                    EQ_status: null
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            // hasAuth: true,
            showModal: true
        };
    },
    created() {
        // this.handleHasAuth();
        // 下次是否展示弹窗
        let hideNext = Cookies.get('StockLastUserId');
        const userId = Cookies.get('userId');
        if (hideNext) {
            hideNext = JSON.parse(hideNext);
            // 判断是否同一个用户
            if (hideNext.userId == userId) {
                this.showModal = !hideNext.isHideNext;
            }
        }
    },
    methods: {
        // async handleHasAuth() {
        //     await console.log('无权限');
        //     if (!this.hasAuth) {
        //         return this.$router.push({
        //             name: "stockDistributionModal"
        //         });
        //     }
        // },
        ajaxRequest: HttpGetStockDistributionList,
        interceptResponse(res) {
            if (this.showModal) {
                this.operate = {
                    show: true,
                    width: 800,
                    component: "compAuthModal",
                    showFooter: false
                };
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "stockDistributionUpdate",
                        params: { type: 'add' }
                    });
                    break;
                case "edit":
                    {
                        // let url = this.$router.resolve({
                        //     name: "stockDistributionUpdate",
                        //     params: { type: "edit" },
                        //     query: { id: params },
                        // });
                        // window.open(url.href, '_blank');
                        this.operate = {
                            show: true,
                            title: "编辑",
                            querytype: "edit",
                            activeid: params,
                            width: 1200,
                            component: "compIndex",
                            showFooter: false
                        };
                    }
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "copy":
                    this.operate = {
                        title: "复制到其他SKU",
                        show: true,
                        width: 800,
                        component: "compCopy",
                        activeid: params,
                        showFooter: false
                    };
                    break;
                case "queryBlank":
                    {
                        let url = this.$router.resolve({
                            name: "stockDistributionUpdate",
                            params: { type: "query" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case "update":
                    this.operate = {
                        show: true,
                        width: 400,
                        title: "批量更新",
                        component: "compUpload",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockBaseTemplate/import",
                        name: "excelFile",
                        download: () => { this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockBaseTemplate/excel", {}, 'download'); }
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        title: "取消",
                        alert: "warning",
                        params: {
                            ids: params
                        },
                        ajaxRequest: HttpCancelStockDistribution
                    };
                    break;
                case 'exportQuery':
                    let queryObj = {}
                    Object.keys(this.formData.search).map(item => {
                        queryObj[`search[${item}]`] = this.formData.search[item]
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockBaseTemplate/export", {
                        ...queryObj,
                        showmessage: 'no'
                    }, {
                        executor: 'request',
                        download: true,
                    }).then(res => {
                    }).catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            const { status } = row
            if (status == 0) {
                return [
                    {
                        label: '查看',
                        show: true,
                        params: id,
                        operate: 'query'
                    },
                    {
                        label: "复制",
                        show: true,
                        params: id,
                        operate: 'copy'
                    }
                ]
            } else {
                return [
                    {
                        label: '查看',
                        show: true,
                        params: id,
                        operate: 'query'
                    },
                    {
                        label: '编辑',
                        show: true,
                        params: id,
                        operate: 'edit'
                    },
                    {
                        label: "复制",
                        show: true,
                        params: id,
                        operate: 'copy'
                    },
                    {
                        label: "取消",
                        show: true,
                        params: id,
                        operate: "cancel"
                    }
                ]
            }

        },
    },
    computed: {
        ...mapGetters('diction', ['getNewDifferentAllProductList', 'getAllCostGroupName', 'getAllCurrency', 'getNewWarehouseIdList', 'getAllSupplier']),
        ...mapGetters('dictionary', ['getWarehouseAllList']),
        TabsData() {
            return [
                {
                    name: "所有",
                    key: 'EQ_status',
                    val: null,
                }, {
                    name: "激活",
                    key: 'EQ_status',
                    val: 1,
                }, {
                    name: "取消",
                    key: 'EQ_status',
                    val: 0,
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                // {
                //     name: "复制",
                //     operate: "copy",
                //     theme: "primary"
                // },
                {
                    name: "批量更新",
                    operate: "update",
                    more: true
                },
                {
                    name: "批量取消",
                    operate: "cancel",
                    more: true,
                    batch: true
                },
                {
                    name: "查询条件导出",
                    operate: "exportQuery",
                    theme: 'info'
                }
            ]
        },
        SearchsData() {
            let stylewidth = "width:210px;"
            return [
                {
                    label: "模板名称",
                    key: 'CN_templateName',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'IN_lineId',
                    options: this.getNewDifferentAllProductList,
                    show: true,
                    props: {
                        filterable: true,
                        multiple: true,
                    }
                },
                {
                    label: "ERPSKU",
                    tag: 'div',
                    key: 'EQ_erpSku',
                    removeInput: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.search.EQ_erpSku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.search.EQ_erpSku = row.erpSku;
                                },
                            }
                        })
                    },
                    style: stylewidth,
                    show: true
                },
                {
                    label: "状态",
                    key: "IN_status",
                    tag: "vSelect",
                    options: [
                        {
                            label: "激活",
                            value: 1
                        },
                        {
                            label: "取消",
                            value: 0
                        }
                    ]
                },
                {
                    label: "描述",
                    key: "CN_description",
                    tag: "vInput",
                },
                {
                    label: "分配比例总和",
                    key: "GE_assignPercent",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    combineKey: 'assignPercent',
                    style: 'width: 95px;'
                },
                {
                    label: '~',
                    key: "LE_assignPercent",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    formItem: {
                        style: "margin-left: -70px"
                    },
                    combineKey: 'assignPercent',
                    style: 'width: 95px;'
                },
                {
                    label: "异常",
                    key: "EQ_isError",
                    tag: "vSelect",
                    options: [
                        {
                            label: "无异常",
                            value: 0
                        },
                        {
                            label: "失效店铺比例未重新分配",
                            value: 1
                        }
                    ]
                }
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    width: 90,
                    render: this.getOperateNodes,
                },
                {
                    title: 'Id',
                    key: "id",
                    // type: "index",
                    width: 50,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.id}</a>
                            </div>
                        );
                    },
                },
                {
                    title: '模板名称',
                    key: 'templateName',
                },
                // ||
                {
                    title: '项目',
                    key: "lineId",
                    render: (h, { row }) => {
                        let lineItem = this.getNewDifferentAllProductList.filter(item => {
                            return item.value == row.lineId;
                        })[0];
                        if (!lineItem) return "--";
                        return lineItem.label;
                    },
                },
                {
                    title: 'ERP SKU',
                    key: "erpSku",
                    render: (h, { row }) => {
                        return row.erpSku || "--";
                    },
                },
                {
                    title: "状态",
                    key: "status",
                    render: (h, { row }) => {
                        let status = this.statusList.filter(item => {
                            return item.value == row.status;
                        })[0];
                        let statusEle = "--";
                        if (status && (status.value == 0 || status.value)) {
                            statusEle = <vButton ghost theme={status.color} size="small" class="cursor-default width-60">{status.label}</vButton>
                        }
                        return statusEle;
                    }
                },
                {
                    title: '更新时间',
                    key: 'updatedAt'
                },
            ];
        },

    },

};
